import { ProfileHoverCard } from "@circle-react/components/Profile/HoverCard";
import { isIntendedOnNewTab } from "@circle-react/helpers/browserHelpers";
import { useProfileLinkProps } from "@circle-react/hooks/profile/useProfileLinkProps";
import type { BasicCommunityMember } from "@circle-react/types/CommunityMember";

import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";

interface MemberRowProps {
  communityMember: BasicCommunityMember;
  onNavigate: () => void;
}

export const MemberRow = ({ communityMember, onNavigate }: MemberRowProps) => {
  const { onClick, href, ...profileLinkProps } = useProfileLinkProps({
    public_uid: communityMember.public_uid,
  });

  return (
    <a
      className="flex items-center gap-3"
      href={href}
      onClick={event => {
        if (!isIntendedOnNewTab(event)) {
          onNavigate();
        }
        onClick?.(event);
      }}
      {...profileLinkProps}
    >
      <ProfileHoverCard
        communityMemberId={communityMember.id}
        name={communityMember.name}
        publicUid={communityMember.public_uid}
        headline={communityMember.headline}
        avatarURL={communityMember.avatar_url}
      >
        <UserImage
          name={communityMember.name}
          src={communityMember.avatar_url}
          size="10"
        />
      </ProfileHoverCard>
      <Typography.LabelSm weight="medium" truncate>
        {communityMember.name}
      </Typography.LabelSm>
    </a>
  );
};
